module.exports = __webpack_public_path__ + "img/icon-media.11189a3b.svg";